export default {
  tabs: {
    accounts: "Accounts",
    report_config: "Report Configuration",
    general: "General",
    billing_notifications: "Billing & Notifications",
    privacy: "Privacy",
    help: "Help",
    about: "About",
  },
  general: {
    title: "General Settings",
    displaySettings: "Display Settings",
    theme: "Theme",
    primaryColor: "Primary Color",
    languageSettings: "Language Settings",
    language: "Language",
    otherSettings: "Other Settings",
    timezone: "Timezone",
    selectTimezone: "Select Timezone",
    dateFormat: "Date Format",
    selectDateFormat: "Select Date Format",
    numberFormat: "Number Format",
    selectNumberFormat: "Select Number Format",
    englishFormat: "English Format",
    europeanFormat: "European Format",
    spaceFormat: "Space Format",
  },
  account: {
    title: "Account Settings",
    subtitle: "Manage your personal information, security settings, and account preferences",
    edit: "Edit",
    save: "Save Changes",
    cancel: "Cancel",
    profile: {
      title: "Personal Information",
      name: "Name",
      email: "Email Address",
      email_tip: "Email address cannot be changed",
      company: "Company",
      phone: "Phone",
      phone_invalid: "Phone number format is invalid",
      bio: "Bio",
      website: "Website",
      website_invalid: "Website URL format is invalid",
      location: "Location",
      position: "Position",
      validation_error: "Form validation failed, please check your inputs",
      change_avatar: "Change Avatar",
      remove: "Remove Avatar",
      save_success: "Profile updated successfully",
      avatar_format_error: "You can only upload JPG/PNG files!",
      avatar_size_error: "Image must be smaller than 2MB!",
      avatar_upload_error: "Avatar upload failed",
      avatar_format_tip: "JPG/PNG format",
      avatar_size_tip: "Maximum file size: 2MB",
      name_placeholder: "Enter your name",
      company_placeholder: "Enter your company",
      phone_placeholder: "Enter your phone number",
      bio_placeholder: "Tell us about yourself",
      website_placeholder: "https://example.com",
      location_placeholder: "Enter your location",
      position_placeholder: "Enter your position",
    },
    security: {
      password_title: "Password Settings",
      password_tip: "For account security, it is recommended to change your password regularly",
      change_password: "Change Password",
      current_password: "Current Password",
      new_password: "New Password",
      confirm_password: "Confirm New Password",
      save_password: "Save Password",
      password_changed: "Password updated",
      password_mismatch: "New password and confirm password do not match",
      password_incorrect: "Current password is incorrect",
      password_required: "Please fill in all password fields",
      password_too_short: "Password must be at least 8 characters long",
      password_change_failed: "Failed to change password",
      two_factor_auth_title: "Two-Factor Authentication",
      two_factor_auth: "Two-Factor Authentication",
      two_factor_auth_desc:
        "Add an extra layer of security that requires both your password and a device verification code to sign in",
      two_factor_auth_coming_soon: "Feature coming soon",
      current_password_placeholder: "Enter current password",
      new_password_placeholder: "Enter new password",
      confirm_password_placeholder: "Confirm new password",
    },
    login_activity: {
      title: "Login Activity",
      manage: "Manage",
      trust_device: "Trust Device",
      logout_device: "Logout Device",
      device_trusted: "Device {location} has been trusted",
      device_logged_out: "Logged out from device {location}",
      showing_details: "Showing details for {location} - IP: {ip}, Time: {time}",
      manage_info: "Managing login activity for {location}",
      login_details: "Login Details",
      ip_address: "IP Address",
      time: "Time",
      isp: "Internet Service Provider",
      bot_score: "Bot Score",
      locations: {
        current: "Current Device",
      },
      suspicious: "Suspicious",
      mobile_device: "Mobile Device",
      api_client: "API Client",
      trusted: "Trusted",
      device: "Device",
      client: "Client",
      unknown: "Unknown",
      risk_reasons: "Risk Reasons",
      location: "Location",
      trust_failed: "Failed to trust device",
      show_more: "Show {0} more",
      show_less: "Show less",
    },
    danger: {
      title: "Danger Zone",
      delete_title: "Delete Account",
      delete_desc:
        "Permanently delete your account and all related data. This action cannot be undone.",
      confirm_title: "Are you sure you want to delete your account?",
      confirm_desc:
        "This action will permanently delete your account and all related data. It cannot be undone.",
      confirm_email_tip: "To confirm deletion, please type your email address:",
      confirm_email_placeholder: "Enter your email address",
      confirm: "Confirm Deletion",
      cancel: "Cancel",
      delete_account: "Delete Account",
      delete_success: "Account deleted successfully",
      email_mismatch: "Email address does not match. Please enter the correct email address.",
    },
  },
  privacy: {
    title: "Privacy Settings",
    privacyPolicyAgreement: "Privacy Policy Agreement",
    privacyPolicyAgreementDesc:
      "You have agreed to our Privacy Policy when registering for an account",
    privacyPolicyAgreementInfo: "Privacy policy agreement cannot be revoked",
  },
  reportConfig: {
    colorPicker: {
      title: "Color Picker",
    },
    currencyName: {
      EUR: "Euro (€)",
      USD: "US Dollar ($)",
      GBP: "British Pound (£)",
    },
    fetchDataFailed: "Failed to fetch data",
    configSelection: "Configuration Selection",
    default: "Default",
    professional: "Professional",
    simple: "Simple",
    custom: "Custom",
    exportType: "Export Type",
    upgradeToUnlock: "Upgrade to unlock this feature",
    commonSettings: "Common Settings",
    tableHeaderFont: "Table Header Font",
    tableCellFont: "Table Cell Font",
    textFont: "Text Font",
    textColor: "Text Color",
    tableHeaderBg: "Table Header Background",
    selectColor: "Select Color",
    dataFormat: "Data Format",
    selectFormat: "Select Format",
    titleFontSize: "Title Font Size",
    watermarkFontSize: "Watermark Font Size",
    titleColor: "Title Color",
    premiumTitleColorActive: "Premium title color is active",
    blue: "Blue",
    red: "Red",
    displayFields: "Display Fields",
    showDate: "Show Date",
    showContact: "Show Contact",
    showEmail: "Show Email",
    showTitle: "Show Title",
    showEmissionDetails: "Show Emission Details",
    showSummary: "Show Summary",
    showTotalDistance: "Show Total Distance",
    showProductionEmission: "Show Production Emission",
    showTransportEmission: "Show Transport Emission",
    showTotalEmission: "Show Total Emission",
    showTax: "Show Tax",
    showCompliance: "Show Compliance Statement",
    privacyFields: "Privacy Fields",
    hideCompanyName: "Hide Company Name",
    hideContact: "Hide Contact",
    hideEmail: "Hide Email",
    hideLogo: "Hide Company Logo",
    hideWeight: "Hide Weight",
    premiumFeatures: "Premium Features",
    generalConfig: "General Configuration",
    language: "Language",
    selectLanguage: "Select Language",
    currency: "Currency",
    selectCurrency: "Select Currency Unit",
    showLogo: "Show Logo",
    companyLogo: "Company Logo",
    logoSupportFormat: "Supported formats: JPG, PNG, GIF, WEBP, Max 2MB",
    showCompany: "Show Company",
    companyName: "Company Name",
    enterCompanyName: "Enter company name",
    customContact: "Custom Contact",
    enterContact: "Enter contact",
    customEmail: "Custom Email",
    enterEmail: "Enter email",
    customCompliance: "Custom Compliance Statement",
    enterCompliance: "Enter compliance statement",
    customFooter: "Custom Footer",
    excelFontStyle: "Font style in Excel is controlled by default settings",
    footerPlaceholder: "eg. TaxEcoBit CBAM Compliance Report",
    showEmissionChart: "Show Emission Chart",
    pdfAdvancedFeatures: "PDF Advanced Features",
    removeWatermark: "Remove Watermark",
    showSignatureArea: "Show Signature Area",
    removeQRCode: "Remove QR Code",
    logoPosition: "Logo Position",
    selectPosition: "Select Position",
    topLeft: "Top Left",
    topRight: "Top Right",
    borderStyle: "Border Style",
    none: "None",
    solid: "Solid",
    premiumTitleColor: "Premium Title Color",
    customTableHeaderBg: "Custom Table Header Background",
    customWatermark: "Custom Watermark",
    enterWatermark: "Enter watermark content",
    inviteText: "Invite Text",
    enterInviteText: "Enter invite text",
    excelAdvancedFeatures: "Excel Advanced Features",
    columnWidth: "Column Width",
    cellBackground: "Cell Background",
    mergeHeader: "Merge Header",
    enableFilter: "Enable Filter",
    addDigitalSignature: "Add Digital Signature",
    signatureContent: "Signature Content",
    enterSignature: "Enter signature content",
    premiumFeaturesDesc: "These premium features can enhance the professionalism of your reports",
    upgradeMessage:
      "Upgrade to premium to unlock language switching, custom logo and other exclusive features",
    lightGray: "Light Gray",
    darkGray: "Dark Gray",
    messages: {
      excelExportRequiresPro: "Excel export requires Pro subscription, switched to PDF",
      logoUploadFailed: "Logo upload failed",
      configSaveSuccess: "Configuration saved successfully",
      configSaveFailed: "Failed to save configuration",
      imageFileOnly: "Only image files are supported!",
      imageSizeLimit: "Image size must not exceed 2MB!",
      fileReadFailed: "File read failed",
    },
  },
  billing: {
    title: "Billing & Notifications",
    compliance: "Compliance Required",
    compliance_desc: "Critical notifications, cannot be disabled",
    service: "Service Critical",
    service_desc: "Recommended to keep enabled",
    experience: "User Experience",
    experience_desc: "Optional, can be turned off",
  },
  notification: {
    title: "Notification Settings",
    policy: "CBAM Policy Updates",
    policy_desc:
      "Receive urgent EU CBAM regulation changes. Required for compliance and penalty avoidance.",
    payment: "Payment Failure Alerts",
    payment_desc: "Get notified immediately if payment fails to prevent service interruption.",
    expiry: "Plan Expiry Reminders",
    expiry_desc:
      "Get notified 3 days before your plan expires. Renew in time to avoid service pause.",
    quota: "Quota Warnings",
    quota_desc: "Alert when you use 80% of monthly calculations. Avoid unexpected limits.",
    ticket: "Support Ticket Updates",
    ticket_desc: "Receive email updates when your support ticket status changes.",
    referral: "Referral Rewards",
    referral_desc: "Get notified when you earn free calculations from successful referrals.",
  },
  info: {
    about_taxecobit: "About TaxEcoBit",
    about_taxecobit_description:
      "TaxEcoBit is a specialized tool crafted for EU SMEs to streamline CBAM carbon emission reporting and compliance. With over 90% accuracy, it enables rapid calculations and report generation, helping mitigate penalty risks (€1K–€10K).",
    our_vision: "Our Vision",
    our_vision_description:
      "We aim to empower EU SMEs with seamless CBAM compliance, driving sustainable growth and supporting the 2026 sustainability goals through innovative solutions.",
    contact_us: "Contact Us",
    follow_us: "Follow us:",
    version_info: "Version Information",
    version: "Version",
    last_updated: "Last Updated",
    license: "License",
    copyright: "© 2025 TaxEcoBit. All rights reserved.",
  },
};
